import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'src/store';
import { setSelectedDateRange } from 'src/app/projects/views/project-list/state/projectListSlice';
import { SelectedDateRange } from 'src/shared/components/filters/date-filter/DateFilter';
import SamplingEventFilter from 'src/shared/components/filters/sampling-event-filter/SamplingEventFilter';
import useProjectFilters, { SamplingEventFilterData } from 'src/shared/hooks/useProjectFilters';
import useDashboardAnalytics from '../../hooks/useDashboardAnalytics';

type SamplingEventDetails = {
    start: SamplingEventFilterData;
    end: SamplingEventFilterData;
};

const DashboardFilters = () => {
    const dispatch = useAppDispatch();
    const { currentProjectSelectedDateRange, currentProjectFilters, currentProjectSelectedHabitatAssayType, samplingEventFilterData } =
        useProjectFilters();
    const { trackDateFilterChange } = useDashboardAnalytics();

    const [samplingEventDetails, setSamplingEventDetails] = useState<SamplingEventDetails>();

    const habitatAssays = currentProjectFilters?.habitatAssays;
    const isSingleTimepoint = !!habitatAssays?.find(entry => entry.key === currentProjectSelectedHabitatAssayType?.key)?.singleTimepoint;

    useEffect(() => {
        if (!samplingEventFilterData || samplingEventFilterData.length === 0) {
            return;
        }
        setSamplingEventDetails({
            start: samplingEventFilterData.at(0) as SamplingEventFilterData,
            end: samplingEventFilterData.at(-1) as SamplingEventFilterData,
        });
    }, [samplingEventFilterData]);

    const onDateRangeChange = (dateRange: SelectedDateRange) => {
        trackDateFilterChange(`${dateRange.startDate} - ${dateRange.endDate}`);
        dispatch(setSelectedDateRange(dateRange));
    };

    if (isSingleTimepoint || !samplingEventDetails?.start) {
        return null;
    }

    const selectedStartSamplingEvent =
        samplingEventFilterData.find(entry => entry.fromDate === currentProjectSelectedDateRange?.startDate) || samplingEventFilterData[0];
    const selectedEndSamplingEvent =
        samplingEventFilterData.find(entry => entry.toDate === currentProjectSelectedDateRange?.endDate) || samplingEventFilterData.at(-1);

    return (
        <div className='flex gap-2 items-center mb-3 justify-end' data-testid='dashboard-date-range-filter'>
            <span>Displaying from</span>
            <SamplingEventFilter
                testId='dashboard-start-sampling-event-filter'
                selectedSamplingEvent={selectedStartSamplingEvent}
                samplingEventFilterData={samplingEventFilterData}
                onChange={value =>
                    onDateRangeChange({
                        startDate: value.fromDate,
                        endDate:
                            currentProjectSelectedDateRange?.endDate || (samplingEventFilterData.at(-1) as SamplingEventFilterData).toDate,
                    })
                }
            />
            <span>to</span>
            <SamplingEventFilter
                testId='dashboard-end-sampling-event-filter'
                selectedSamplingEvent={selectedEndSamplingEvent as SamplingEventFilterData}
                samplingEventFilterData={samplingEventFilterData}
                onChange={value =>
                    onDateRangeChange({
                        startDate: currentProjectSelectedDateRange?.startDate || samplingEventFilterData[0].fromDate,
                        endDate: value.toDate,
                    })
                }
            />
        </div>
    );
};

export default DashboardFilters;
